import {
  memo, useCallback,
} from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useAnalytics } from 'use-analytics';
import { throttle } from 'lodash';
import { updateFlightSearchObj } from '../../../../../store/slices/flight';
import SingleSelectAutocompleteFilter from '../../../../Filters/SingleSelectAutocompleteFilter';
import { autocompleteRequest } from '../../../../../store/slices/autocomplete';
import { labelForEmptyFlightOrigin } from '../../../../../constants';
import flightSearchInput from '../../../../../helpers/selectors/flightSearchInput';
import { setFlightTripSearchInputs } from '../../../../../store/slices/tripSearch';

const FromFlightFilter = ({
  tripId,
  type,
  autocompleteType,
  autocompleteResultsType,
  selectedItemName,
  trackEventName,
  variant,
  filterButtonMaxWidth,
  doHighlightOnChange,
  index,
}) => {
  const dispatch = useDispatch();
  const { track } = useAnalytics();
  const isTripSearch = !tripId;
  const { searchInputs, defaultSearchObj } = useSelector(flightSearchInput(tripId, isTripSearch));
  const autocompleteResults = useSelector((store) => store.autocomplete[autocompleteResultsType]);

  const defaultValue = false && defaultSearchObj && defaultSearchObj.flightSegments
    && defaultSearchObj.flightSegments[index]
    && defaultSearchObj.flightSegments[index]
    && defaultSearchObj.flightSegments[index][selectedItemName];

  const label = defaultValue ? defaultValue.label : labelForEmptyFlightOrigin[type];
  const value = searchInputs && searchInputs.flightSegments && searchInputs.flightSegments[index]
    && searchInputs.flightSegments[index][selectedItemName] && (!defaultValue
      || defaultValue.label !== searchInputs.flightSegments[index][selectedItemName].label)
    ? searchInputs.flightSegments[index][selectedItemName] : null;

  const handleChange = (newValue) => {
    const payload = {
      tripId,
      searchObj: {
        flightSegments: searchInputs.flightSegments ? [...searchInputs.flightSegments] : [],
        page: 1,
      },
    };
    payload.searchObj.flightSegments[index] = {
      ...payload.searchObj.flightSegments[index],
      [selectedItemName]: newValue ? { ...newValue } : defaultValue,
    };
    if (isTripSearch) dispatch(setFlightTripSearchInputs({ ...payload.searchObj }));
    else dispatch(updateFlightSearchObj(payload));
    track(`${trackEventName}.handleChange`, {
      [trackEventName]: JSON.stringify(newValue),
    });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleInputChange = useCallback(
    throttle((query) => {
      dispatch(autocompleteRequest({
        autocompleteTypes: autocompleteType,
        responseType: autocompleteResultsType,
        query,
      }));
    }, 50), [dispatch, autocompleteType, autocompleteResultsType],
  );

  return (
    <SingleSelectAutocompleteFilter
      onChange={handleChange}
      label={label}
      options={autocompleteResults}
      value={value}
      variant={variant}
      filterButtonMaxWidth={filterButtonMaxWidth}
      onInputChange={handleInputChange}
      doHighlightOnChange={doHighlightOnChange}
      bgClassName={isTripSearch ? 'bg-searchInput-0' : ''}
    />
  );
};

FromFlightFilter.propTypes = {
  tripId: PropTypes.string,
  type: PropTypes.string.isRequired,
  autocompleteType: PropTypes.arrayOf(PropTypes.number).isRequired,
  autocompleteResultsType: PropTypes.string.isRequired,
  trackEventName: PropTypes.string.isRequired,
  selectedItemName: PropTypes.string.isRequired,
  variant: PropTypes.string,
  filterButtonMaxWidth: PropTypes.string,
  doHighlightOnChange: PropTypes.bool,
  index: PropTypes.number,
};

FromFlightFilter.defaultProps = {
  variant: 'outline',
  filterButtonMaxWidth: 'max-w-full',
  doHighlightOnChange: true,
  tripId: undefined,
  index: 0,
};

export default memo(FromFlightFilter);
